module.exports = __webpack_public_path__ + "img/SC5-Income_&_savings.81d05552.png";